import { SET_PRICING_TEMPLATES, SET_WEIGHT_TOLERANCES } from '../types/pricingTemplate'

const initState = {
  pricingTemplates: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_PRICING_TEMPLATES:
      return {
        ...state,
        pricingTemplates: action.payload.pricingTemplates,
        lastModified: new Date().getTime(),
      }
    case SET_WEIGHT_TOLERANCES:
      return { ...state, weightTolerances: action.payload.weightTolerances }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pricingTemplate.js